import { createSelector } from 'reselect';

const FREE = ['free'];
const getLanguage = (state) => state?.config?.language ?? {};
const getMbox = (state) => state?.config?.mbox;
const getAppEnt = (state) => {
    const el = state?.userinfo?.entitlements;
    if (!el || el?.length === 0) {
        return FREE;
    }

    return el;
};
const getTeams = (state) => {
    const teams = state?.boxscore?.teams;
    if (!teams || teams?.length === 0) {
        return [];
    }

    return teams;
};

const getSeason = (state) => state?.gumbo?.gameData?.game?.season ?? '';

const getAdsConf = (state) => state?.config?.ads ?? {};

const getVideoConfig = (state) => getAdsConf(state)?.video ?? {};

const getEnabledAdSources = (state) => {
    const adConfig = state?.productConfig?.midInningAdConfig ?? {};
    const adSources = getVideoConfig(state)?.adSources ?? [];
    return adSources.filter(source =>
        (source === 'aps' && adConfig.apsVideo) ||
        (source === 'publica' && adConfig.publicaVideo)
    );
};

export const getVideoPlayerState = createSelector(
    [getLanguage, getMbox, getAppEnt, getTeams, getSeason, getEnabledAdSources, getVideoConfig],
    (language, mbox, appEntitlements, teams, season, enabledAdSources, videoConfig) => {
        return {
            language,
            mbox,
            entitlement: appEntitlements,
            teamNames: teams,
            season,
            enabledAdSources,
            videoConfig
        };
    }
);
